module.exports = __webpack_public_path__ + "img/side-point.c56b82f3.svg";